import { render } from "./Philosophy.vue?vue&type=template&id=16c29b70&scoped=true"
import script from "./Philosophy.vue?vue&type=script&lang=js"
export * from "./Philosophy.vue?vue&type=script&lang=js"

import "./Philosophy.vue?vue&type=style&index=0&id=16c29b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c29b70"]])

export default __exports__